var map = {
	"./Header": 975,
	"./Header.tsx": 975,
	"./Hello": 979,
	"./Hello.js": 979,
	"./collections/approveModal": 798,
	"./collections/approveModal.tsx": 798,
	"./collections/create": 1228,
	"./collections/create.tsx": 1228,
	"./collections/like": 1229,
	"./collections/like.tsx": 1229,
	"./common/header": 1230,
	"./common/header.tsx": 1230,
	"./common/modal": 882,
	"./common/modal.tsx": 882,
	"./myEthWallet/connect": 1231,
	"./myEthWallet/connect.tsx": 1231,
	"./walletConnect/walletConnect": 1232,
	"./walletConnect/walletConnect.tsx": 1232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1237;